<template>
  <div
    class="slider"
    :class="{
      'slider--small': !props.isShowRangeLine,
    }"
  >
    <div
      ref="sliderTrack"
      class="slider-track"
      :class="{
        'slider-track--small': props.isSmall,
      }"
    >
      <input
        type="range"
        class="slider-input"
        ref="minInput"
        :min="props.min"
        @input="calculateSliderOneMin"
        :max="props.max"
        :step="props.step"
        :value="props.minValue"
      />
      <input
        type="range"
        class="slider-input"
        ref="maxInput"
        :min="props.min"
        @input="calculateSliderTwoMax"
        :max="props.max"
        :step="props.step"
        :value="props.maxValue"
      />
    </div>
    <div class="slider-values" v-if="isShowRangeLine">
      <div class="slider-values__num" v-for="(item, index) in computedLabelsNumList" :key="index">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType, computed, onMounted, ref, defineEmits } from "vue";

// define component props for the slider component
const props = defineProps({
  /**
   * Минимальное значение для слайдера
   */
  min: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Максимальное значение для слайдера
   */
  max: {
    type: Number as PropType<number>,
    default: 100,
  },
  /**
   * Размер шага значение для слайдера
   */
  step: {
    type: Number as PropType<number>,
    default: 1,
  },
  /**
   * Двойной ли слайдер
   */
  isDouble: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Показывать ли линейку
   */
  isShowRangeLine: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Маленький ли размер
   */
  isSmall: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Разбег минимальной границы
   */
  stepToMove: {
    type: Number as PropType<number>,
    default: 1,
  },
  /**
   * Разбег минимальной границы. Значение которое устанавливается для инпута
   */
  minValue: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Разбег Максимальной границы. Значение которое устанавливается для инпута
   */
  maxValue: {
    type: Number as PropType<number>,
    default: 100,
  },
});
/**
 * Тип для передаваемых данных
 */
type MoveDataType = {
  value: number | string;
  percent: number | string;
  difference?: number | string;
};
/**
 * События
 */
const emit = defineEmits<{
  (eventName: "minValue", value: MoveDataType): void;
  (eventName: "maxValue", value: MoveDataType): void;
}>();
/**
 * Элементы
 */
const minInput = ref<HTMLInputElement>(null);
const maxInput = ref<HTMLInputElement>(null);
const sliderTrack = ref<HTMLInputElement>(null);
/**
 * Заполнение лейблов для значений
 */
const computedLabelsNumList = computed(() => {
  let calcLebels = [];
  calcLebels[0] = props.min;
  calcLebels[1] = Math.floor((props.max - props.min) / 2);
  calcLebels[2] = props.max;
  console.log(calcLebels);
  return calcLebels;
});

onMounted(() => {
  calculateSliderOneMin();
  calculateSliderTwoMax();
  if (!props.isDouble) {
    console.log(maxInput.value.classList);
    minInput.value.classList.add("slider-input--hide");
  }
});

/**
 * Срабатывает при событии инпута в шаблоне.
 * Просчитывает ширину заполнителя и отправляет событие
 */
const calculateSliderOneMin = () => {
  if (Number(maxInput.value.value) - Number(minInput.value.value) <= props.stepToMove) {
    minInput.value.value = (Number(maxInput.value.value) - props.stepToMove).toString();
  }
  computedFillColor();
  emit("minValue", {
    value: minInput.value.value,
    percent: ((Number(minInput.value.value) - props.min) / (props.max - props.min)) * 100,
    ...(props.isDouble && {
      difference: Number(maxInput.value.value) - Number(minInput.value.value),
    }),
  });
};
/**
 * Срабатывает при событии инпута в шаблоне.
 * Просчитывает ширину заполнителя и отправляет событие
 */
const calculateSliderTwoMax = () => {
  if (Number(maxInput.value.value) - Number(minInput.value.value) <= props.stepToMove) {
    maxInput.value.value = (Number(minInput.value.value) + props.stepToMove).toString();
  }
  computedFillColor();
  emit("maxValue", {
    value: maxInput.value.value,
    percent: ((Number(maxInput.value.value) - props.min) / (props.max - props.min)) * 100,
    ...(props.isDouble && {
      difference: Number(maxInput.value.value) - Number(minInput.value.value),
    }),
  });
};
/**
 *
 * Просчитывает ширину заполнителя
 */
const computedFillColor = () => {
  let percentMin = ((Number(minInput.value.value) - props.min) / (props.max - props.min)) * 100;
  let percentMax = ((Number(maxInput.value.value) - props.min) / (props.max - props.min)) * 100;
  if (props.isDouble) {
    sliderTrack.value.style.background = `linear-gradient(to right, var(--neutral-10) ${percentMin}% , var(--accent) ${percentMin}% , var(--accent) ${percentMax}%, var(--neutral-10) ${percentMax}%)`;
  } else {
    sliderTrack.value.style.background = `linear-gradient(to right,  var(--accent) ${percentMax}%, var(--neutral-10) ${percentMax}%)`;
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
